import { isDefinedArray } from "et3-type-guards";
import { Chart, registerables } from "chart.js";
import { Bar } from "react-chartjs-2";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { TDataBarChart } from "../../Types";
import ET3Div from "../et3-div";

const Et3BarChart = withLiteObserverAndTheme<TDataBarChart>((props) => {
  Chart.register(...registerables);
  const { title, dataLabels, values, theme } = props;
  const { colors } = theme;
  const data = {
    labels: dataLabels,
    datasets: [
      {
        label: "Count",
        data: values,
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgb(54, 162, 235)",
        borderWidth: 1
      }
    ]
  };

  return isDefinedArray(values) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1500}
      height={500}
      color={colors.all.white}
      style={{
        borderBottom: `1px solid ${colors.all.lightGray}`,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      <Bar
        data={data}
        options={{
          plugins: {
            legend: {
              display: false
            },
            title: {
              display: true,
              text: title,
              font: {
                size: 25
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                // beginAtZero: true,
              }
            }
          },
          animation: {
            duration: 1000,
            easing: "linear"
          },
          responsive: true
        }}
      />
    </ET3Div>
  ) : null;
});

export default Et3BarChart;
